/* src/app/account/partials/price-list-section/price-list-section.component.scss */
/*# sourceMappingURL=price-list-section.component.css.map */
